import { SIUnitPrefix } from "./SIUnitPrefix";

export class SIUnitConverter
{
  static convert( value:number, from:SIUnitPrefix, to:SIUnitPrefix )
  {
    let multiply = Math.pow( 10, from - to );    
    return value * multiply;
  }

  static fromBase( value:number, to:SIUnitPrefix )
  {
    let multiply = Math.pow( 10, - to );
    return value * multiply;
  }

  static toBase( value:number, from:SIUnitPrefix )
  {
    let multiply = Math.pow( 10, from );
    return value * multiply;
  }
} 